export * from './src/focus.trap';